import { useEffect } from "react";

import { useAccount } from "./useAccount";

/**
 * Temporary production-safe mode. The light palette is being reworked and is
 * deliberately not applied until every surface has visual coverage.
 */
export function ThemeController() {
  const { account } = useAccount();

  useEffect(() => {
    document.documentElement.dataset.theme = "dark";
  }, [account?.preferences.theme]);

  return null;
}
